/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * The copyright caption service implementation. Provides a caption that is supposed to be display on link providing to
 * full copyright notice. The response is not changed often.
 *
 * This service is supposed to be called once when user have the map displayed for the first time.
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "CopyrightCaption/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    {{#crossLink "CopyrightCaption/go:method"}}{{/crossLink}} method to handle the response.
 *
 * @example
 * ```js
 * tomtom.copyrightCaption()
 *   .go()
 *   .then(function(response) {
 *     console.log(response);
 *   });
 * ```
 *
 * @class CopyrightCaption
 * @module Services
 * @uses Chain
 * @constructor
 * @uses KeyMixin
 * @uses ProtocolMixin
 *
 * @param {Object} [options]
 * @param {String} [options.key] This is optional if a key was already defined globally
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 */
define(['rest/copyright', 'model/copyright/copyrightCaption', 'services/chain', 'services/validators'],
    function(copyright, model, chain, validators) {
        'use strict';
        var fields = {
            key: {validator: validators.string},
            protocol: {validator: validators.oneOfValue(['http', 'https'], 'protocol')}
        };

        /**
         * Perform the actual call to the web service.
         *
         * It receives two optional arguments. The first one is a callback function that will be used when a
         * successful response if received by the web service. The second one is another callback function
         * that will be used only in case of failure.
         *
         * Both arguments are shortcuts for the <b>callback</b> and <b>fail</b> methods respectively.
         *
         * The final response from service is a string containing the caption i.e.:
         *     © 1992 - 2016 TomTom.
         *
         * This text have to be displayed as a copyright prompt when using TomTom services. The caption should be
         * clickable. User should be presented with full copyright notice when caption is clicked. For further
         * documentation please check the caption class.
         *
         * The SDK provides a Promise polyfill for browsers (IE<9) without native ECMAScript 6 support.
         *
         * @method go
         * @param {Function} [success] The callback function to be called on case of success.
         * @param {Function} [fail] The callback function to be called on case of failure.
         *     If a success callback is not given this argument will be ignored. In that case the returned Promise
         *     should be used to handle the failures.
         * @return {Promise|null} If the success callback is omitted (and wasn't defined one yet) this function
         *     will return a Promise
         */

        function handleChain(data, callback) {
            copyright.caption(fields, data, function(response) {
                callback.call(this, model(response));
            });
        }

        return function(options) {
            return chain(fields, handleChain, options);
        };
    });



// WEBPACK FOOTER //
// ./services/copyrights/copyrightCaption.js